import styled, { css } from 'styled-components'
import { ButtonIcon, Title, tokens } from '@arvoreeducacao/bonsai-ds'
import type { ContentProps } from './interface'

export const BOTTOM_NAVIGATION_HEIGHT = 48
export const CHAT_WIDGET_WIDTH = 65
export const CHAT_WIDGET_RIGHT = 15

export const BackgroundGradient = styled.div`
  background: linear-gradient(
    180deg,
    ${tokens.colors.livrosLight} 0%,
    ${tokens.colors.white} 190px
  );
  width: 100%;
  height: 190px;
  position: absolute;
  z-index: 0;
`

export const StyledContent = styled.div<ContentProps>`
  z-index: 1;

  ${({ noPaddingForMobileScreen, noPaddingForAnyScreen, noWidth }) => css`
    padding: ${noPaddingForMobileScreen || noPaddingForAnyScreen
      ? 0
      : '20px 0px 20px 0px'};
    padding-bottom: ${BOTTOM_NAVIGATION_HEIGHT + 20}px;
    width: 100%;
    height: auto;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    @media (min-width: ${tokens.breakpoints.tablet}px) {
      width: ${noWidth ? '100%' : tokens.breakpoints.tablet - 20 + 'px'};
      padding: ${noPaddingForAnyScreen ? 0 : '40px 20px'};
    }
    @media (min-width: ${tokens.breakpoints.desktop}px) {
      width: ${noWidth ? '100%' : tokens.breakpoints.desktop - 20 + 'px'};
    }
    @media (min-width: ${tokens.breakpoints.desktopLarge}px) {
      width: ${noWidth ? '100%' : tokens.breakpoints.desktopLarge - 20 + 'px'};
    }
    @media (min-width: ${tokens.breakpoints.desktopXlarge}px) {
      width: ${noWidth ? '100%' : tokens.breakpoints.desktopXlarge - 20 + 'px'};
    }
  `};
`
const { verticalXxlarge, horizontalMedium } = tokens.spacing

export const ContentBody = styled.div`
  margin-left: auto;
  margin-right: auto;
  max-width: ${tokens.breakpoints.desktopXlarge}px;
  padding: ${tokens.spacing.verticalXlarge} ${tokens.spacing.horizontalMedium};
  width: 100%;
  flex-grow: 1;

  @media (min-width: ${tokens.breakpoints.desktop}px) {
    padding: ${verticalXxlarge} ${horizontalMedium};
  }
`

export const TitleBackground = styled.div`
  background-color: ${tokens.colors.dark1};

  > div {
    padding-top: 0;
    padding-bottom: 0;
  }
`

export const ContentExemple = styled.div`
  width: 100%;
  background-color: ${tokens.colors.primary};
  border-radius: 16px;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: ${tokens.spacing.verticalLarge};
`

export const HeaderBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  padding: ${tokens.spacing.verticalXxxlarge} 0;

  @media (max-width: ${tokens.breakpoints.desktop}px) {
    padding: 0;
  }
`

export const BodyTitle = styled(Title)`
  margin-bottom: ${tokens.spacing.verticalXlarge};

  @media (max-width: ${tokens.breakpoints.desktop}px) {
    display: none;
  }

  @media (min-width: ${tokens.breakpoints.desktop}px) {
    display: none;
  }
`

export const TitleBox = styled.div`
  display: flex;

  @media (max-width: ${tokens.breakpoints.desktop}px) {
    display: none;
  }
`

export const HeaderTitle = styled(Title)`
  display: none;
  margin-left: ${tokens.spacing.horizontalLarge};

  @media (min-width: ${tokens.breakpoints.desktop}px) {
    display: block;
  }
`

export const HeaderSubtitle = styled.p`
  margin: 0;
  color: ${tokens.colors.dark6};
  font-size: ${tokens.fontSize.small};
  line-height: ${tokens.lineHeight.medium}%;
  margin-left: 72px;
  margin-top: 17px;
`

export const ButtonIconRound = styled(ButtonIcon)`
  border-radius: ${tokens.radius.circular};
  background-color: ${tokens.colors.white};
  padding: 0;
  justify-content: left;
  box-shadow: ${tokens.shadows.centerMedium};

  @media (min-width: ${tokens.breakpoints.desktop}px) {
    justify-content: center;
  }
`
